export default "__VITE_ASSET__C21lhUN5__"